import { z } from '@harvestiq/zod';
import { safeDbUserSchema } from './db-user';

export const blockUsersRequestBodySchema = z.object({
  ids: z.array(z.string().uuid()).min(1),
});
export type BlockUsersRequestBody = z.infer<typeof blockUsersRequestBodySchema>;

export const blockUsersResponseSchema = z
  .object({
    users: safeDbUserSchema.array(),
  })
  .or(
    z.object({
      errors: z.string().array(),
    })
  );
export type BlockUsersResponse = z.infer<typeof blockUsersResponseSchema>;
